import { createAsyncUseCase } from '@/utils/dva-model-creator/async';
import { categoryWidgetsContext } from './constants';
import { ICategoryPageRequestData, ICategoryPageResponse, ICategoryWidgetsState } from './typing';

export const { action: getCategoryPageAction, hook: getCategoryPageHook } = createAsyncUseCase<
  ICategoryPageRequestData,
  ICategoryPageResponse,
  ICategoryWidgetsState
>(categoryWidgetsContext, 'getCategoryPage');
